/** 判断元素是否可见 */
export const isInViewPort = (element) => {
  const viewWidth = window.innerWidth || document.documentElement.clientWidth;
  const viewHeight = window.innerHeight || document.documentElement.clientHeight;
  const { top, right, bottom, left } = element.getBoundingClientRect();
  return top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight;
};

export function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      func.apply(context, args);
    }, wait);
  };
}
export function throttle(func, limit) {
  let inThrottle;
  let last;
  return function() {
    const context = this;
    const args = arguments;
    if (!inThrottle) {
      clearTimeout(last);
      func.apply(context, args);
      inThrottle = true;
      setTimeout(function() {
        inThrottle = false;
      }, limit);
    } else {
      // 保证最后一次，会调用
      clearTimeout(last);
      last = setTimeout(() => {
        console.log('throttle last exec!!!');
        func.apply(context, args);
      }, limit);
    }
  };
}
